import { GOTO_ORDERS } from '../actions/NavigationActions';

export const nav = (state = null, action) => {
  switch (action.type) {
    case GOTO_ORDERS:
      return null;
    default:
      return state;
  }
}

export default nav;


// WEBPACK FOOTER //
// ./src/reducers/nav.js